import { render, staticRenderFns } from "./PreviewVideoModal.vue?vue&type=template&id=517fc61a&scoped=true"
import script from "./PreviewVideoModal.vue?vue&type=script&lang=js"
export * from "./PreviewVideoModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewVideoModal.vue?vue&type=style&index=0&id=517fc61a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517fc61a",
  null
  
)

export default component.exports